export const vaultTokens = ["mBTC", "MUSD"] as const

export type VaultTokens = (typeof vaultTokens)[number]

export type VaultDepositFormValue = {
  amount: bigint | undefined
  token: VaultTokens
}
